<template>
  <div
    class="relative z-40 rounded-lg border border-gray-900 bg-gray-700 p-4 text-sm text-white"
  >
    <div class="flex flex-col gap-1">
      <!-- Message -->
      <div class="flex items-start gap-2">
        <BaseIcon name="notification-2" filled class="text-lg" />
        <p class="font-bold">{{ title }}</p>
      </div>
      <p v-if="message">{{ message }}</p>
      <!-- Action -->
      <BaseButton
        v-if="action"
        color="primary"
        small
        class="mt-1 w-fit"
        @click="action"
      >
        {{ actionLabel ?? "Meer informatie" }}
      </BaseButton>
    </div>
    <!-- Close -->
    <BaseButton
      color="lightgray"
      minimal-dark
      square
      small
      class="absolute! top-2 right-2 border-0!"
      @click="hide"
    >
      <BaseIcon name="close" class="fill-white text-xl" />
    </BaseButton>
    <!-- Show count -->
    <div
      v-if="count > 1"
      class="bg-primary absolute -top-1 -left-1 flex size-6 items-center justify-center rounded-full text-sm text-white"
    >
      {{ count }}
    </div>
  </div>
</template>

<script setup>
import useNotificationStore from "@/stores/notificationStore.js"
import { BaseButton, BaseIcon } from "@repowerednl/ui-component-library"

const notificationStore = useNotificationStore()

const props = defineProps({
  uid: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    default: null,
  },
  action: {
    type: Function,
    default: null,
  },
  actionLabel: {
    type: String,
    default: null,
  },
  count: {
    type: Number,
    default: 1,
  },
})

function hide() {
  notificationStore.remove(props.uid)
}
</script>
